import { css } from "lit";

export const holloEmbedStyles = css`
  :host {
    position: fixed;
    bottom: 20px;
    right: 20px;
    /* Use extremely high z-index to sit above host page UI */
    z-index: 2147483647;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
  }

  @media (max-width: 460px) {
    :host {
      bottom: 10px;
    }
  }

  /* Desktop width, adjust popup for shorter viewport heights */
  @media (min-width: 461px) and (max-height: 900px) {
    .hollo-popup-gradient-minimalist {
      height: 520px;
      max-height: 85dvh !important;
    }
  }
  @media (min-width: 461px) and (max-height: 750px) {
    .hollo-popup-gradient-minimalist {
      height: 460px;
      max-height: 80dvh !important;
    }
  }
  @media (min-width: 461px) and (max-height: 650px) {
    .hollo-popup-gradient-minimalist {
      height: 420px;
      max-height: 75dvh !important;
    }
  }

  .hollo-widget {
    position: relative;
  }

  /* Remove gradient effects from default trigger - only gradient-minimalist button should have effects */

  @keyframes hollo-gradient-pulse {
    0%,
    100% {
      opacity: 0.4;
      transform: scale(1);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.08);
    }
  }

  /* Only apply gradient-minimalist popup styles when class is present */
  .hollo-popup-gradient-minimalist {
    background: #fafafa;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 400px;
    height: 580px;
    max-height: 88dvh;
  }

  /* Ellipse decoration at center-right - only for gradient-minimalist */
  .hollo-popup-gradient-minimalist::before {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    width: 880px;
    height: 880px;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgwIiBoZWlnaHQ9Ijg4MCIgdmlld0JveD0iMCAwIDg4MCA4ODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9mXzE1NV80MDUpIj4NCjxjaXJjbGUgY3g9IjQ0MCIgY3k9IjQ0MCIgcj0iMTQwIiBmaWxsPSIjRDVGRkZDIi8+DQo8L2c+DQo8ZGVmcz4NCjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZl8xNTVfNDA1IiB4PSIwIiB5PSIwIiB3aWR0aD0iODgwIiBoZWlnaHQ9Ijg4MCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPg0KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4NCjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+DQo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxNTAiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl8xNTVfNDA1Ii8+DQo8L2ZpbHRlcj4NCjwvZGVmcz4NCjwvc3ZnPg0K");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center right;
    transform: translate(50%, -50%);
    pointer-events: none;
    z-index: 0;
  }

  /* Ellipse decoration at bottom-left - only for gradient-minimalist */
  .hollo-popup-gradient-minimalist::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 880px;
    height: 880px;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgwIiBoZWlnaHQ9Ijg4MCIgdmlld0JveD0iMCAwIDg4MCA4ODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9mXzE1NV83NDIpIj4NCjxjaXJjbGUgY3g9IjQ0MCIgY3k9IjQ0MCIgcj0iMTQwIiBmaWxsPSIjRjNBMUNCIi8+DQo8L2c+DQo8ZGVmcz4NCjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZl8xNTVfNzQyIiB4PSIwIiB5PSIwIiB3aWR0aD0iODgwIiBoZWlnaHQ9Ijg4MCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPg0KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4NCjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+DQo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxNTAiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl8xNTVfNzQyIi8+DQo8L2ZpbHRlcj4NCjwvZGVmcz4NCjwvc3ZnPg0K");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom left;
    transform: translate(-50%, 50%);
    filter: blur(100px);
    pointer-events: none;
    z-index: 0;
  }

  /* Nudge tooltip above the trigger */
  .hollo-nudge {
    position: absolute;
    right: 0;
    bottom: 76px; /* 64px trigger + 12px gap */
    width: 240px;
    background: linear-gradient(135deg, #9333ea 0%, #ec4899 100%);
    color: #fff;
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 13px;
    line-height: 1.2;
    box-shadow: 0 10px 30px rgba(147, 51, 234, 0.3);
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 8px;
    animation: hollo-slideUp 0.25s ease-out;
  }
  .hollo-nudge-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hollo-nudge-dismiss {
    background: transparent;
    border: none;
    color: #e5e7eb;
    cursor: pointer;
    font-size: 14px;
    padding: 2px 4px;
    border-radius: 6px;
  }
  .hollo-nudge-dismiss:hover {
    background: rgba(255, 255, 255, 0.08);
  }
  .hollo-nudge-arrow {
    position: absolute;
    right: 18px;
    bottom: -6px;
    width: 12px;
    height: 12px;
    background: #111827;
    transform: rotate(45deg);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
  }

  .hollo-popup-gradient-minimalist .hollo-content {
    padding: 64px 16px 16px 16px;
  }

  .hollo-content {
    flex: 1;
    overflow: auto;
    background: transparent;
    border: none;
    border-bottom: none;
    position: relative;
    z-index: 1;

    /* Custom scrollbar styles */
    --sb-track-color: #ffffff;
    --sb-thumb-color: #d1d5db;
    --sb-size: 3px;
  }

  /* Prevent scrolling when error panel is shown */
  .hollo-content:has(.hollo-error-panel) {
    overflow: hidden;
  }

  @media (max-width: 460px) {
    .hollo-popup-gradient-minimalist .hollo-content {
      padding: 70px 16px 20px 16px;
    }
  }

  .hollo-content::-webkit-scrollbar {
    width: 0;
    display: none;
  }

  .hollo-content::-webkit-scrollbar-track {
    display: none;
  }

  .hollo-content::-webkit-scrollbar-thumb {
    display: none;
  }

  @supports not selector(::-webkit-scrollbar) {
    .hollo-content {
      scrollbar-width: none;
      scrollbar-color: transparent transparent;
    }
  }
  
  .hollo-content {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .hollo-spinner-wrap {
    height: 100%;
    display: grid;
    gap: 10px;
    place-items: center;
    color: #111827;
  }
  .hollo-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e5e7eb;
    border-top-color: #4f46e5;
    border-radius: 50%;
    animation: hollo-spin 0.9s linear infinite;
  }
  .hollo-spinner-text {
    font-size: 13px;
    color: #6b7280;
  }

  .hollo-conn-banner {
    margin: 6px 16px 0;
    padding: 8px 10px;
    border-radius: 10px;
    font-size: 12px;
    color: #92400e;
    background: #fffbeb;
    border: 1px solid #fbbf24;
  }
  .hollo-conn-banner.hollo-conn-banner--error {
    color: #7f1d1d;
    background: #fee2e2;
    border-color: #ef4444;
  }

  .hollo-error-panel {
    height: 100%;
    min-height: 0;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #111827;
    padding: 40px 24px;
    gap: 0;
    box-sizing: border-box;
    overflow: hidden;
  }
  .hollo-error-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin-bottom: 24px;
    background: #fef2f2;
    border-radius: 50%;
    flex-shrink: 0;
  }
  .hollo-error-icon-wrapper svg {
    color: #ef4444;
  }
  .hollo-error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 400px;
  }
  .hollo-error-title {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.3;
    color: #111827;
    margin: 0;
    letter-spacing: -0.02em;
  }
  .hollo-error-desc {
    font-size: 15px;
    line-height: 1.6;
    color: #6b7280;
    margin: 0;
    font-weight: 400;
  }

  .hollo-toast-container {
    position: absolute;
    top: 70px;
    left: 12px;
    right: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    z-index: 1000;
    pointer-events: none;
  }

  .hollo-toast {
    pointer-events: auto;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 14px;
    padding: 10px 14px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 12px;
    animation: hollo-toast-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.2)
      forwards;
    max-width: 100%;
    margin: 0 auto;
    width: fit-content;
    min-width: 220px;
  }

  .hollo-toast-icon {
    font-size: 16px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  .hollo-toast-content {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .hollo-toast-text {
    font-size: 13px;
    font-weight: 600;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: -0.01em;
  }

  .hollo-toast-count {
    font-size: 11px;
    background: rgba(0, 0, 0, 0.05);
    padding: 1px 6px;
    border-radius: 10px;
    color: #6b7280;
    font-weight: 700;
  }

  .hollo-toast-close {
    background: transparent;
    border: none;
    color: #9ca3af;
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .hollo-toast-close:hover {
    background: rgba(0, 0, 0, 0.05);
    color: #4b5563;
  }

  .hollo-toast.hollo-toast--warning {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .hollo-toast.hollo-toast--warning .hollo-toast-icon {
    background: transparent;
  }

  .hollo-toast.hollo-toast--error {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .hollo-toast.hollo-toast--error .hollo-toast-icon {
    background: transparent;
  }

  .hollo-toast.hollo-toast--success {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .hollo-toast.hollo-toast--success .hollo-toast-icon {
    background: transparent;
  }

  @keyframes hollo-toast-in {
    from {
      transform: translateY(-20px) scale(0.9);
      opacity: 0;
    }
    to {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }

  @keyframes hollo-slideUp {
    from {
      transform: translateY(12px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes hollo-spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* Gradient trigger button for gradient_minimalist style */
  .hollo-trigger-gradient-minimalist {
    height: 40px;
    padding: 0 20px;
    border-radius: 999px;
    background: var(
      --hollo-trigger-bg,
      linear-gradient(to right, #3784ff 0%, #ff8b8d 50%, #3784ff 100%)
    );
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    font-size: 12px;
    font-weight: 600;
    color: white;
    letter-spacing: 0.02em;
    outline: none;
    z-index: inherit;
    box-shadow: none;
  }

  /* Show shadows only when popup is open */
  .hollo-trigger-gradient-minimalist.hollo-trigger--active {
    box-shadow: 0 10px 60px var(--hollo-trigger-shadow, rgba(255, 175, 175, 0.5)),
      10px 20px 80px rgba(255, 197, 218, 0.3),
      -20px -10px 50px rgba(19, 229, 213, 0.4),
      inset 0 0 20px rgba(238, 238, 238, 0.5);
  }

  .hollo-trigger-gradient-minimalist:focus {
    outline: none;
  }

  .hollo-trigger-gradient-minimalist.hollo-trigger--active:hover {
    box-shadow: 0 10px 60px var(--hollo-trigger-shadow, rgba(255, 175, 175, 0.5)),
      10px 20px 80px rgba(255, 197, 218, 0.3),
      -20px -10px 50px rgba(19, 229, 213, 0.4),
      inset 0 0 20px rgba(238, 238, 238, 0.5);
    transform: translateY(-1px);
  }

  .hollo-trigger-gradient-minimalist:active {
    opacity: 0.9;
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(55, 132, 255, 0.2),
      0 0 0 1px rgba(255, 255, 255, 0.15) inset;
  }

  .hollo-trigger-gradient-minimalist svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    color: white;
    fill: white;
  }

  .hollo-trigger-gradient-minimalist span {
    white-space: nowrap;
    color: white;
  }

  /* Language menu positioning for gradient-minimalist - align to right top where flag button is */
  .hollo-popup-gradient-minimalist hollo-language-menu {
    position: absolute;
    top: 0;
    right: 0;
    left: auto;
    z-index: 100;
  }

  @media (max-width: 460px) {
    .hollo-popup {
      width: 100vw;
      max-width: 100vw;
      right: -20px;
      height: 100dvh;
      max-height: 100dvh;
      bottom: -10px;
      border-radius: 0;
    }
  }
`;
